module.exports = __webpack_public_path__ + "img/led_in_switch_alice.972ad9ef.png";